import EmbeddedFormPage from './EmbeddedFormPage';

const BusinessCoachingSurveyPage = () => (
  <EmbeddedFormPage
    titleKey="Business Coaching Survey"
    description="Fill out this short survey to get matched with a Business Coach. Business Coaching is a 1:1 program that helps you grow enrollment, improve operations, and hit your revenue goals."
    formUrl="https://wonderschool.typeform.com/to/hXvinXoC"
  />
);

export default BusinessCoachingSurveyPage;
